(() => {
  const COMPONENT_NAME = 'vl-bottom-floating-bar';

  if (customElements.get(COMPONENT_NAME)) return;

  class VlBottomFloatingBar extends HTMLElement {
    constructor() {
      super();
      this.ticking = false;
      this.handleScroll = this.handleScroll.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.handleSectionSelect = this.handleSectionSelect.bind(this);
      this.handleSectionDeselect = this.handleSectionDeselect.bind(this);
    }

    connectedCallback() {
      this.showAfter = Math.max(0, Number(this.dataset.showAfter) || 0);
      this.isDesignMode = this.dataset.designMode === 'true';
      this.updateVisibility();

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      this.addEventListener('click', this.handleClick);

      if (this.isDesignMode) {
        document.addEventListener('shopify:section:select', this.handleSectionSelect);
        document.addEventListener('shopify:section:deselect', this.handleSectionDeselect);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('shopify:section:select', this.handleSectionSelect);
      document.removeEventListener('shopify:section:deselect', this.handleSectionDeselect);
    }

    handleScroll() {
      if (this.ticking) return;

      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.updateVisibility();
        this.ticking = false;
      });
    }

    handleClick(event) {
      const link = event.target.closest('a[href^="#"]');
      if (!link || !this.contains(link)) return;

      let target;
      try {
        target = document.querySelector(link.getAttribute('href'));
      } catch (error) {
        return;
      }

      if (!target) return;

      event.preventDefault();
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start',
      });

      const href = link.getAttribute('href');
      if (window.location.hash !== href) window.history.pushState(null, '', href);
    }

    handleSectionSelect(event) {
      if (!this.closest(`#shopify-section-${event.detail.sectionId}`)) return;
      this.setVisible(true);
    }

    handleSectionDeselect(event) {
      if (!this.closest(`#shopify-section-${event.detail.sectionId}`)) return;
      this.updateVisibility();
    }

    updateVisibility() {
      this.setVisible(window.scrollY >= this.showAfter);
    }

    setVisible(isVisible) {
      this.classList.toggle('is-visible', isVisible);
      this.toggleAttribute('inert', !isVisible);
      this.setAttribute('aria-hidden', String(!isVisible));
    }
  }

  customElements.define(COMPONENT_NAME, VlBottomFloatingBar);
})();
